export const numberLayer = [
  { value: 2, text: '2' },
  { value: 4, text: '4' },
];
